/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Components } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

// Styling
import styles from './styles';

// Spinner Framework
var Spinner = require('react-spinkit');

class Loader extends React.Component {
  render() {
    const { classes, theme, location } = this.props;
    return (
      <div className={classes.root}>
        <div>
          <Spinner name="chasing-dots" color="steelblue"/>
        </div>
        <Typography className={classes.textStyling} type="sub-heading" color="primary" gutterBottom align="center">
          Welcome to the Dating Service Network. Please wait while we load your content.
        </Typography>
      </div>
    )
  }
}

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles, { withTheme: true })(Loader));



// WEBPACK FOOTER //
// ./src/components/Loader/index.js